class LocationData {
  constructor(
    cityLocation,
    href,
    googleMapsLink,
    address,
    officeEmail,
    officePhone,
    fax
  ) {
    this.cityLocation = cityLocation;
    this.href = href;
    this.googleMapsLink = googleMapsLink;
    this.address = address;
    this.officeEmail = officeEmail;
    this.officePhone = officePhone;
    this.fax = fax;
  }
}

const Tacoma = {
  locationData: new LocationData(
    "Tacoma",
    "/office/tacoma",
    "https://goo.gl/maps/QJ9Wt2kCiPPx7NNK8",
    "5006 Center St Suite N, Tacoma, WA 98409",
    "epictacoma@epic-pt.com",
    "(253) 476-3333",
    "(253) 476-3334"
  ),
};

const Bellevue = {
  locationData: new LocationData(
    "Bellevue",
    "/office/bellevue",
    "https://goo.gl/maps/4JZpCiBoFiJTEDbU6",
    "13353 Bel-Red Rd #103, Bellevue, WA 98005",
    "epicbellevue@epic-pt.com",
    "(425) 679-5996",
    "(425) 968-7590"
  ),
};

const FederalWay = {
  locationData: new LocationData(
    "Federal Way",
    "/office/federal-way",
    "https://goo.gl/maps/AZNU6GhSC6AfK4UHA",
    "728 S 320th St Suite G, Federal Way, WA 98003",
    "epicfw@epic-pt.com",
    "(206) 212-6352",
    "(206) 249-8086"
  ),
};

const Lakewood = {
  locationData: new LocationData(
    "Lakewood",
    "/office/lakewood",
    "https://goo.gl/maps/qWQ4QGLch3TMdwGy8",
    "8511 S Tacoma Way Ste #303, Lakewood, WA 98499",
    "epiclakewood@epic-pt.com",
    "(253) 426-1244",
    "(253) 503-7565"
  ),
};

const Olympia = {
  locationData: new LocationData(
    "Olympia",
    "/office/olympia",
    "https://goo.gl/maps/24T4BsVmo19WSbX4A",
    "3000 Limited Ln NW #100, Olympia, WA 98502",
    "epicoly@epic-pt.com",
    "(360) 292-7245",
    "(360) 292-7247"
  ),
};

const Puyallup = {
  locationData: new LocationData(
    "Puyallup",
    "/office/puyallup",
    "https://goo.gl/maps/TqbTX9zwpgXoGF5t9",
    "16515 Meridian Ave E Ste 202B, Puyallup, WA 98375",
    "epicpuyallup@epic-pt.com",
    "(253) 466-3178",
    "(253) 466-3886"
  ),
};

const Sumner = {
  locationData: new LocationData(
    "Sumner",
    "/office/sumner",
    "https://goo.gl/maps/MMWWXn1gA1hisiFD7",
    "5814 Graham Ave #101, Sumner, WA 98390",
    "epicsumner@epic-pt.com",
    "(253) 891-7093",
    "(253) 891-1033"
  ),
};

export { Tacoma, Bellevue, FederalWay, Lakewood, Olympia, Puyallup, Sumner };
